import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth',
  templateUrl: './auth-landing.component.html',
  styleUrls: ['./auth-landing.component.css']
})
export class AuthLandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
